import React from 'react';
import { useTranslation, Trans } from 'react-i18next';
import Modal from 'components/modal/modal';
import styles from './levelTransferModal.module.scss';

interface LevelTransferModalProps {
  isOpen: boolean;
  onClose: () => void;
}

const LevelTransferModal: React.FC<LevelTransferModalProps> = ({ isOpen, onClose }) => {
  const { t } = useTranslation();

  return (
    <Modal
      isOpen={isOpen}
      onClose={onClose}
      title={t('levelTransferModal.title', 'Transfer Your Existing Level')}
    >
      <div className={styles.content}>
        <p>
          <Trans
            i18nKey="levelTransferModal.description"
            defaults="If you have an established level or status on another iGaming platform, we don't want you to start from scratch. Dgenta offers a <strongTag>Level Match</strongTag> program to honor your loyalty and past play."
            components={{ strongTag: <strong /> }}
          />
        </p>

        <div className={styles.highlightBox}>
          <h4>{t('common.howItWorks', 'How it works')}</h4>
          <p>
            {t(
              'levelTransferModal.howItWorksText',
              'You can request a level transfer by contacting our support team. You will need to provide valid proof of your existing level, such as a screenshot showing your username and current tier on the external platform.',
            )}
          </p>
        </div>

        <p>
          <em>
            {t(
              'levelTransferModal.note',
              '* Please note that automatic approval or guaranteed level matching is not promised. All requests are subject to verification and eligibility checks by our team.',
            )}
          </em>
        </p>

        <a
          href="mailto:support@dgenta.com?subject=Level Transfer Request"
          className={styles.supportBtn}
          onClick={onClose}
        >
          {t('common.writeToSupport', 'Write to Support')}
        </a>
      </div>
    </Modal>
  );
};

export default LevelTransferModal;
